export type MergeValues = {
  first_name?: string | null;
  last_name?: string | null;
  rep_name?: string | null;
  property_address?: string | null;
};

const TOKEN = /\{(first_name|last_name|rep_name|property_address)\}/g;

/** Fills {first_name}, {last_name}, {rep_name}, and {property_address}. */
export function applyMergeFields(
  template: string,
  values: MergeValues,
): string {
  return template.replace(TOKEN, (_match, key: keyof MergeValues) => {
    const value = values[key];
    return value == null ? "" : value;
  });
}
